import React from "react";
import { Link } from "react-router-dom";

const FaqTwo = () => {
  return (
    <>
      
      <div className="overflow-hidden">
        <div className="bg-max-container bg-smoke radius-50">
          {/* Event Area / Benefícios Area  */}
          <div className="event-area-1 space overflow-hidden">
            <div className="container">
              <div className="row gy-50 align-items-center flex-row-reverse">
                <div className="col-lg-6">
                  <div className="event-thumb-2 text-lg-end">
                    <img
                      src="assets/img/home/6.png"
                      alt="Consultoria Estratégica em RH Grupo Rocvel"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="title-area mb-4">
                    <span className="sub-title">
                      <img src="assets/img/icon/title_left.svg" alt="shape" />
                      Vantagens Competitivas
                    </span>
                    <h2 className="sec-title style2">
                      Elimine gargalos operacionais e transforme seu RH em um motor de resultados.
                    </h2>
                    <p className="sec-text mt-3">
                      Contratações erradas geram custos altíssimos e sobrecarregam sua equipe. Ao terceirizar ou otimizar seu recrutamento com o Grupo Rocvel, você assume o controle da sua operação, ganha previsibilidade e foca no que realmente importa: o crescimento do seu negócio.
                    </p>
                  </div>
                  <div className="accordion-area accordion" id="eventAccordion">
                    <div className="accordion-card style4 active">
                      <div
                        className="accordion-header"
                        id="event-collapse-item-1"
                      >
                        <button
                          className="accordion-button "
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#event-collapse-1"
                          aria-expanded="true"
                          aria-controls="event-collapse-1"
                        >
                          Agilidade na Contratação
                        </button>
                      </div>
                      <div
                        id="event-collapse-1"
                        className="accordion-collapse collapse show"
                        aria-labelledby="event-collapse-item-1"
                        data-bs-parent="#eventAccordion"
                      >
                        <div className="accordion-body">
                          <p className="event-text">
                            Redução drástica do tempo de contratação e eliminação de perda de produtividade por vagas abertas.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-card style4">
                      <div
                        className="accordion-header"
                        id="event-collapse-item-2"
                      >
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#event-collapse-2"
                          aria-expanded="false"
                          aria-controls="event-collapse-2"
                        >
                          Retenção de Talentos
                        </button>
                      </div>
                      <div
                        id="event-collapse-2"
                        className="accordion-collapse collapse "
                        aria-labelledby="event-collapse-item-2"
                        data-bs-parent="#eventAccordion"
                      >
                        <div className="accordion-body">
                          <p className="event-text">
                            Diminuição de turnover (rotatividade) devido à maior assertividade e ao mapeamento rigoroso de perfil.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-card style4">
                      <div
                        className="accordion-header"
                        id="event-collapse-item-3"
                      >
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#event-collapse-3"
                          aria-expanded="false"
                          aria-controls="event-collapse-3"
                        >
                          Eficiência e Economia
                        </button>
                      </div>
                      <div
                        id="event-collapse-3"
                        className="accordion-collapse collapse "
                        aria-labelledby="event-collapse-item-3"
                        data-bs-parent="#eventAccordion"
                      >
                        <div className="accordion-body">
                          <p className="event-text">
                            Economia operacional, ganho de produtividade e processos seletivos muito mais organizados.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-card style4">
                      <div
                        className="accordion-header"
                        id="event-collapse-item-4"
                      >
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#event-collapse-4"
                          aria-expanded="false"
                          aria-controls="event-collapse-4"
                        >
                          Segurança Jurídica
                        </button>
                      </div>
                      <div
                        id="event-collapse-4"
                        className="accordion-collapse collapse "
                        aria-labelledby="event-collapse-item-4"
                        data-bs-parent="#eventAccordion"
                      >
                        <div className="accordion-body">
                          <p className="event-text">
                            Segurança, confiabilidade e conformidade legal em todas as etapas do processo de recrutamento.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <Link to="/contato" className="global-btn">
                      Solicitar Diagnóstico de RH Gratuito
                      <img src="assets/img/icon/right-icon.svg" alt="Seta Direita Rocvel" style={{ marginLeft: "10px" }} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqTwo;